// extracted by mini-css-extract-plugin
export default {"timeline":"Timeline_timeline__c2rlB","tick":"Timeline_tick__ItFVb","label":"Timeline_label__G5nMX","tickMark":"Timeline_tickMark__bGt6P","subTick":"Timeline_subTick__yOc2D"};